import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Environment} from '../../constants';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent implements OnInit {
  @Input() showSocialLinks: boolean = true;

  appVersion: string = '';
  currentYear: number = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
    // Get application version from environment if available
    if (Environment.appVersion) {
      this.appVersion = Environment.appVersion;
    }
  }
}
